import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import RegStrip from "../components/RegStrip.jsx";
import { fetchTransactions, statusClass } from "../lib/cms.js";
import { transactions as txFallback } from "../data/transactions.js";

export default function Home() {
  const [tx, setTx] = useState(null);

  useEffect(() => {
    fetchTransactions().then((data) => {
      const list = data && data.length ? data : txFallback.map((t, i) => ({ id: i, ...t }));
      setTx(list.slice(0, 4));
    });
  }, []);

  // Hide Structure column on the home teaser if no row has it
  const showStructure = tx && tx.some((t) => t.structure && t.structure.toString().trim() && t.structure !== "—");

  return (
    <>
      {/* HERO */}
      <section className="hero">
        <div className="wrap hero-grid">
          <div>
            <div className="pill">
              <span className="live"></span>
              Daksfirst Group · London &middot; Mumbai &middot; Cayman &middot; Luxembourg
            </div>
            <h1>A merchant banking group across the UK, India and Frontier Markets.</h1>
            <p className="sub">
              Daksfirst Limited operates as an Appointed Representative of Maystone Capital
              Limited, authorised and regulated by the Financial Conduct Authority. FRN 758412
              · AR registration 937220.
            </p>
          </div>
          <div className="mark" aria-hidden="true">
            <img src="/df-logo.png" alt="Daksfirst monogram" />
          </div>
        </div>
      </section>

      {/* TWO BIG CHOICE CARDS */}
      <section className="choice">
        <div className="wrap">
          <div className="choice-grid choice-grid-3">
            <Link to="/invest" className="choice-card">
              <div className="eyebrow">For institutional investors</div>
              <h2>Invest with us.</h2>
              <p>Three channels: direct deals, regulated fund vehicles, or operating credit platforms.</p>
              <ul className="choice-list">
                <li>Direct deals — co-invest alongside Daksfirst</li>
                <li>Funds — Cayman, Luxembourg, India SEBI Cat II AIF</li>
                <li>Platforms — UK Bridging, Whole Loan, Hospitality, KIFPL</li>
              </ul>
              <span className="choice-go">See ways to invest →</span>
            </Link>

            <Link to="/borrow" className="choice-card">
              <div className="eyebrow">For sponsors and borrowers</div>
              <h2>Borrow from us.</h2>
              <p>Bespoke credit from $5m to $100m, secured against operational cashflow or assets.</p>
              <ul className="choice-list">
                <li>Direct credit — bespoke structures via the funds</li>
                <li>UK platforms — Bridging, BTL, Hospitality</li>
                <li>India — KIFPL, our RBI-registered NBFC</li>
              </ul>
              <span className="choice-go">See ways to borrow →</span>
            </Link>

            <Link to="/wealth" className="choice-card">
              <div className="eyebrow">For HNW and family offices</div>
              <h2>Manage your wealth.</h2>
              <p>Discretionary portfolios across public markets, structured products and the group&rsquo;s own private credit.</p>
              <ul className="choice-list">
                <li>Discretionary portfolio management</li>
                <li>Structured products with major issuers</li>
                <li>Allocations into Daksfirst private credit</li>
              </ul>
              <span className="choice-go">See wealth services →</span>
            </Link>
          </div>
        </div>
      </section>

      {/* TRACK RECORD — recent closed deals (live from CMS) */}
      <section className="funds-section">
        <div className="wrap">
          <div className="funds-head">
            <div>
              <div className="eyebrow">Track record</div>
              <h2 style={{ color: "var(--white)", marginTop: 14 }}>Recent closed deals.</h2>
            </div>
            <Link className="btn btn-ghost" to="/transactions">See full track record →</Link>
          </div>

          <div className="table-wrap">
            <table className="portfolio">
              <thead>
                <tr>
                  <th>Jurisdiction</th>
                  <th>Sector</th>
                  {showStructure && <th>Structure</th>}
                  <th>Amount</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {tx === null && (
                  <tr><td colSpan={showStructure ? 5 : 4} style={{ textAlign: "center", padding: "32px 0", color: "var(--white-65)" }}>Loading…</td></tr>
                )}
                {tx && tx.map((t) => (
                  <tr key={t.id}>
                    <td>{t.jurisdiction || "—"}</td>
                    <td>{t.sector || "—"}</td>
                    {showStructure && <td>{t.structure || "—"}</td>}
                    <td><b>{t.amount || "—"}</b></td>
                    <td>
                      <span className={`status-pill ${statusClass(t.status)}`}>
                        {t.status || "Closed"}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* WHO WE ARE — fund teaser */}
      <section className="group">
        <div className="wrap">
          <div className="grid">
            <div>
              <div className="eyebrow">The group</div>
              <h2>Three regulated fund vehicles.</h2>
            </div>
            <div className="body">
              <p>
                Daksfirst manages three regulated fund vehicles &mdash; a Cayman-domiciled
                Emerging and Frontier Markets fund, a Luxembourg feeder, and Daksfirst India
                Special Situations Fund I, a SEBI Category II AIF based in Mumbai.
              </p>
              <p>
                Group infrastructure runs on technology built by Cepheus Analytics, the group's
                in-house analytics and loan-origination arm.
              </p>
              <Link className="btn btn-ghost spacer-m" to="/group">More about the group →</Link>
            </div>
          </div>
        </div>
      </section>

      <RegStrip />
    </>
  );
}
